import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { AlarmClock, Youtube } from "lucide-react";
import { toast } from "sonner";
import { useCountdown } from "@/hooks/useCountdown";
import { CHANNEL_HANDLE, CHANNEL_URL } from "@/constants/campaign";

const pad = (n) => String(n).padStart(2, "0");

export default function StickyCta() {
  const [visible, setVisible] = useState(false);
  const { hours, minutes, seconds } = useCountdown();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 620);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="sticky-bottom-cta"
          initial={{ y: 96 }}
          animate={{ y: 0 }}
          exit={{ y: 96 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-red-600/30 bg-[#FFFFFF]/90 backdrop-blur-xl"
        >
          <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-3 sm:flex-row sm:px-6">
            <p className="flex items-center gap-2 text-sm font-bold text-slate-800">
              <AlarmClock className="h-4 w-4 text-red-500" />
              Timer is ticking —
              <span className="font-timer tabular-nums text-red-500">{pad(hours)}:{pad(minutes)}:{pad(seconds)}</span>
              <span className="hidden sm:inline">complete your 3 YouTube steps now.</span>
            </p>
            <a
              data-testid="sticky-bottom-cta-button"
              href={CHANNEL_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => toast.success(`Opening ${CHANNEL_HANDLE} on YouTube…`)}
              className="flex items-center gap-2 rounded-xl bg-gradient-to-r from-red-500 via-red-500 to-red-600 px-6 py-3 text-sm font-black tracking-wide text-white shadow-[0_0_25px_rgba(255,0,0,0.45)] transition-all duration-200 hover:scale-[1.03] active:scale-[0.98]"
            >
              <Youtube className="h-4 w-4" />
              Go To YouTube Channel
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
